/**
 * Microsoft 365 Copilot calls our agents (docs/plans/2026-10-copilot-calls-our-agents.md): what the
 * organisation keeps and the console reads. AIOE-only; the wire contract with the workbench is
 * ./a2a.ts, mirrored from the workbench.
 *
 *   GET    /admin/v1/a2a/settings              who may make agents callable
 *   PUT    /admin/v1/a2a/settings              administrators
 *   GET    /projects/v1/:id/a2a/agents         the project's callable agents, and what could be
 *   POST   /projects/v1/:id/a2a/agents         make one callable (administrators; owners when allowed)
 *   DELETE /projects/v1/:id/a2a/agents/:agent  stop it being callable
 *   GET    /projects/v1/:id/a2a/tasks          the tasks asked of it, newest first
 *
 *   GET    /a2a/v1/agents/:agent/.well-known/agent-card.json   public, the A2A agent card
 *   POST   /a2a/v1/agents/:agent                               A2A JSON-RPC, a person's Entra token with Agents.Invoke
 */
import { z } from "zod";
import { a2aArtifactSchema, a2aCallerSchema, a2aKindSchema, a2aQuestionSchema, a2aRefSchema, a2aStateSchema } from "./a2a.js";
/** Who may make an agent callable: administrators only, or a project's owners too (for that project). */
export const a2aWhoMayExposeSchema = z.enum(["admins", "adminsAndOwners"]);
export const a2aSettingsSchema = z.object({ whoMayExpose: a2aWhoMayExposeSchema.default("adminsAndOwners") });
export const a2aExposurePostSchema = z.object({
    kind: a2aKindSchema,
    ref: a2aRefSchema,
    member: z.string().min(1).max(100).optional(),
    name: z.string().trim().min(1).max(100),
    description: z.string().trim().max(1000).optional(),
});
/** One A2A task, as the console lists it: who asked, from which Copilot agent, how it stands. Never the message's text. */
export const a2aTaskViewSchema = z.object({
    id: z.string(),
    agentId: z.string(),
    projectId: z.string(),
    kind: a2aKindSchema,
    ref: z.string(),
    member: z.string().optional(),
    name: z.string(),
    principal: z.string(),
    caller: a2aCallerSchema,
    state: z.union([a2aStateSchema, z.literal("rejected")]),
    question: a2aQuestionSchema.optional(),
    artifacts: z.array(a2aArtifactSchema.pick({ artifactId: true, name: true, links: true })),
    deviceId: z.string().optional(),
    refusal: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=a2aAdmin.js.map